// extracted by mini-css-extract-plugin
export default {"installBtn":"install-extension-btn_installBtn__q+AA6","installBtnViolet":"install-extension-btn_installBtnViolet__rMBqC","disabled":"install-extension-btn_disabled__mE8sV"};